import React from 'react';
import { Box } from '@mui/material';
import { node } from 'prop-types';

const Title = ({ headline }) => (
  <Box
    sx={{
      height: '22px',
      mb: '5px',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSize: '12px',
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '-0.3px',
      color: '#8b98ab',
      lineHeight: 1.83,
      textTransform: 'uppercase',
    }}
  >
    {headline}
  </Box>
);
Title.propTypes = {
  headline: node.isRequired,
};

export default Title;
